import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChangePasswordPage from '../pages/ChangePasswordPage';

// Layout-route sifatida ishlatiladi (children prop emas, <Outlet/> orqali) —
// himoyalangan har bir sahifa route'i shu ostida joylashadi (App.js).
export default function ProtectedRoute() {
  const { isAuthenticated, initialized, customer } = useSelector((s) => s.auth);
  if (!initialized) {
    return (
      <div className="min-h-screen-safe flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Standart "1111" parol bilan (yoki xodim tomonidan tiklangan parol bilan)
  // kirgan bo'lsa — yangi parol o'rnatilmaguncha ilovaning qolgan qismiga
  // (qaysi sahifa bo'lishidan qat'i nazar) o'tkazilmaydi.
  if (customer?.mustChangePassword) return <ChangePasswordPage />;
  return <Outlet />;
}
